<template>
	<ActivityPublicCom />
</template>

<script>
import ActivityPublicCom from '@/views/Brand/ActivityPublic/main';
export default {
  name: 'ActivityPublic',

  components:{
    ActivityPublicCom
  },

  data () {
    return {
    }
  },

  computed: {

  },

  created() {
  },

  mounted() {},
}
</script>


<style lang='scss'>
</style>
